import { Component, Input } from '@angular/core';
import { AppliedFilter, BaseFilter } from '@shared/components/filters/Domain/filter.model';
import { ChipModule } from 'primeng/chip';
import { NgForOf, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CustomerCaseListWorkflowOperationFilter } from '@modules/customer-case-campaings-instances/Model/workflow-insitance.model';
import { WorkflowSharedService } from '@shared/services/workflow-shared.service';

@Component({
  selector: 'app-composed-filter-display',
  standalone: true,
  imports: [ChipModule, NgForOf, NgIf, TranslateModule],
  templateUrl: './composed-filter-display.component.html',
  styleUrl: './composed-filter-display.component.scss',
})
export class ComposedFilterDisplayComponent {
  @Input() filter!: AppliedFilter<BaseFilter>;

  constructor(private workflowSharedService: WorkflowSharedService) {}

  operationLabelMap: Record<string, string> = {
    [CustomerCaseListWorkflowOperationFilter.InCampaign]: 'En campaña',
    [CustomerCaseListWorkflowOperationFilter.NotInCampaign]: 'No en campaña',
    [CustomerCaseListWorkflowOperationFilter.HasBeenInCampaign]: 'Ha estado en campaña',
    [CustomerCaseListWorkflowOperationFilter.HasNotBeenInCampaign]: 'Nunca ha estado en campaña',
  };

  get operationLabel(): string {
    return this.operationLabelMap[this.filter.value.operation] || this.filter.value[0].label;
  }

  get workflowNames(): string[] {
    const map = this.workflowSharedService.getWorkflowMap();
    const normalized = this.normalizeFilterValue(this.filter.value);
    const isUlid = (val: string) => /^[0-9A-HJKMNP-TV-Z]{26}$/.test(val);

    return normalized.ids.filter((id: string) => isUlid(id)).map((id: string) => map.get(id) || id);
  }

  private normalizeFilterValue(value: any): { operation: string; ids: string[] } {
    // Already normalized, come from session storage
    if (value?.operation && Array.isArray(value?.ids)) {
      return value;
    }

    //Should be normalized, come from change filter
    if (Array.isArray(value)) {
      const operationItem = value.find((v: any) => v.dropdown === 'dropdown-0');
      const operation = operationItem?.value || '';

      const ids = value
        .filter((v: any) => v.dropdown === 'dropdown-1')
        .map((v: any) => v.value)
        .filter((v: any) => typeof v === 'string');

      return { operation, ids };
    }

    // Default fallback
    return { operation: '', ids: [] };
  }
}
